/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Ask_User_Skipped_Count_OneInputs */



/**
* | output |
* | --- |
* | "Skipped 1 question" |
*
* @param {Chat_Ask_User_Skipped_Count_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_ask_user_skipped_count_one = /** @type {((inputs?: Chat_Ask_User_Skipped_Count_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Ask_User_Skipped_Count_OneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("1 Frage übersprungen")
	return /** @type {LocalizedString} */ ("Skipped 1 question")
});